import React from 'react'

const Reload = ({ onClick }) => {
  return (
    <div className="tpm-Replay" onClick={onClick}>
      Replay
    </div>
  )
}

export default Reload
